import http from "./Endpoint";
import { appConstant } from "config/constant";

class CustomerService {

  getById(data) {
    return http().post("/customer/getById", data);
  }

  getPaymentMethods(data) {
    return http().post("/customer/getPaymentMethods", data);
  }

  getDeliveryMethods(data) {
    return http().post("/customer/getDeliveryMethods", data);
  }

  getDepartments(data) {
    return http().post("/customer/getDepartments", data);
  }

  getBillingAddresses(data) {
    return http().post("/customer/getBillingAddresses", data);
  }

  getOrderTypes(data) {
    return http().post("/customer/getOrderTypes", data);
  }

  /**
   * Return customer list
   * @param {*} filter
   */
  query(data) {
    return http().post("/customer/query", data);
  }

  update() {

  }

  add(data) {

  }

}

// eslint-disable-next-line  
export default new CustomerService();